<template>
  <ChatModal
    name="add-users-to-chat"
    :title="$t('chat.addParticipantsTitle')"
    @before-open="beforeOpen"
  >
    <div slot="default">
      <UserList
        :users="users"
        :class="$style.list"
        mode="select"
        :selectedUsers.sync="selectedUsers"
        :infiniteHandler="infiniteHandler"
      />
    </div>
    <template v-slot:footer>
      <BaseButton oval @click="onSubmit">{{ $t('buttonAdd') }}</BaseButton>
    </template>
  </ChatModal>
</template>

<script>
import ChatModal from './ChatModal'
import UserList from '@/components/UserList'
import { mapGetters, mapActions } from 'vuex'

const LIMIT = 20

export default {
  name: 'add-users-to-chat-popup',
  components: {
    ChatModal,
    UserList
  },
  data () {
    return {
      loading: false,
      chatId: null,
      selectedUsers: []
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      // allUsers: 'entities/users/all',
      contacts: 'entities/users/contacts',
      getChat: 'entities/chats/getById'
    }),
    users () {
      if (!this.chat) return []
      return this.contacts.filter(user => !this.chat.participants.includes(user.id))
    },
    chat () {
      return this.getChat(this.chatId)
    },
    page () {
      return parseInt(this.contacts.length / LIMIT) + 1
    }
  },
  methods: {
    beforeOpen ({ params: { chatId } }) {
      this.selectedUsers = []
      this.chatId = chatId
      this.loading = false
    },
    ...mapActions({
      addParticipants: 'entities/participants/add',
      fetchContactsUsers: 'entities/users/fetchContactsUsers'
    }),
    async onSubmit () {
      this.loading = true
      await this.addParticipants({
        chatId: this.chatId,
        participants: this.selectedUsers
      })
      this.loading = false
      this.$modal.hide('add-users-to-chat')
    },
    async infiniteHandler ($state) {
      const data = await this.fetchContactsUsers({
        page: this.page + 1,
        limit: LIMIT
      })
      if (data.length && data.length === LIMIT) {
        $state.loaded()
      } else {
        $state.complete()
      }
    }
  }
}
</script>

<style lang="scss" module>

.list :global(.gl-user-list-item) {
  padding-left: 15px;
  padding-right: 15px;
}
</style>
